// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { MrAppMain } from '@ion/components';
import { OrganizationOverrideTable } from './components/OrganizationOverrideTable';

export const OrganizationOverridePage = () => {
  return (
    <MrAppMain styleNames="noBackground">
      <OrganizationOverrideTable />
    </MrAppMain>
  );
};
